// A component that can act as an absolute link, relative Gatsby link, or call a function
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, NoSsr, Typography } from '@material-ui/core';

import { classifyAction } from 'services/link';

import Link from './Link';

const useStyles = makeStyles(theme => ({
	button: {
		color: theme.palette.brand.teal,
		cursor: 'pointer',
		fontWeight: 900,
		letterSpacing: 1,
		textTransform: 'uppercase',
		'&:hover,&:active,&:focus': {
			textDecoration: 'underline',
		},
	},
}));

const Wrapper = ({ className, text, title, ...props }) => {
	const classes = useStyles();

	return (
		<Typography
			title={title}
			aria-label={title}
			className={`${classes.button} ${className ? className : ''}`}
			{...props}
		>
			{text} &rarr;
		</Typography>
	);
};

const TextButton = ({ action, ...props }) => {
	const actionType = classifyAction(action);

	switch (actionType) {
		case 'absoluteUrl':
			return <Wrapper component="a" href={action} {...props} />;
		case 'relativeUrl':
			return <Wrapper component={Link} to={action} {...props} />;
		case 'function':
		default:
			return (
				<NoSsr>
					<Wrapper component="a" onClick={action} {...props} />
				</NoSsr>
			);
	}
};

TextButton.propTypes = {
	action: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
	text: PropTypes.string.isRequired,
	title: PropTypes.string,
};

export default TextButton;
